import React from 'react';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { strings } from '../../../resources/strings';
import { Row } from './styles';

export type CustomerBasicDataType = {
    firstName?: string;
    lastName?: string;
    phone?: string;
    documentNumber?: string;
    email?: string;
}

interface ITabBasicDataProps {
    basicData?: CustomerBasicDataType|null;
    setBasicData: (basicData: CustomerBasicDataType) => void;
    editCustomerId?: number;
}

const TabBasicData: React.FC<ITabBasicDataProps> = ({
    basicData,
    setBasicData,
    editCustomerId
}) => {

    return (
        <>
            <Row>
                <Field
                    type={FieldType.Text}
                    label={`${strings.Name} *`}
                    value={basicData?.firstName}
                    change={(value) => setBasicData( basicData ? { ...basicData, firstName: value } : { firstName: value })}
                    marginTop='0px'
                    marginRight='5px'
                    marginRightMobile='0px'
                    autoFocus={true}
                />
                <Field
                    type={FieldType.Text}
                    label={`${strings.LastName} *`}
                    value={basicData?.lastName}
                    change={(value) => setBasicData( basicData ? { ...basicData, lastName: value } : { lastName: value })}
                    marginTop='0px'
                    marginLeft='5px'
                    marginLeftMobile='0px'
                />
            </Row>
            <Row>
                <Field
                    type={FieldType.Phone}
                    label={strings.Phone}
                    value={basicData?.phone}
                    change={(value) => setBasicData( basicData ? { ...basicData, phone: value } : { phone: value })}
                    marginTop={'0px'}
                    marginRight='5px'
                    marginRightMobile='0px'
                />
                <Field
                    type={FieldType.Text}
                    label={'CPF ou CNPJ'}
                    value={basicData?.documentNumber}
                    change={(value) => setBasicData( basicData ? { ...basicData, documentNumber: value } : { documentNumber: value })}
                    marginLeft='5px'
                    marginLeftMobile='0px'
                    marginTop={'0px'}
                    maxLength={14}
                />
            </Row>
            <Row>
                <Field
                    type={FieldType.Email}
                    label={`${strings.Email} *`}
                    value={basicData?.email}
                    change={(value) => setBasicData( basicData ? { ...basicData, email: value } : { email: value })}
                    marginTop={'0px'}
                />
            </Row>
        </>
    );
}

export {TabBasicData};